import React from "react";
import { Check, Loader2 } from "lucide-react";
import { useTranslation } from "react-i18next";
import type { StageAutosaveStatus } from "../hooks/useStageAutosave";

/** Bottom-right „Се снима… / ✓ Снимено" for the stage-table autosave (Норматив и РН). */
const AutosaveStatusPill: React.FC<{ status: StageAutosaveStatus }> = ({ status }) => {
  const { t } = useTranslation();
  if (!status) return null;
  return (
    <div className="fixed bottom-4 right-4 z-50 flex items-center gap-1.5 rounded-lg border border-gray-200 bg-white px-3 py-1.5 text-xs text-gray-700 shadow-md">
      {status === "saving"
        ? <Loader2 className="w-3.5 h-3.5 animate-spin text-blue-500" />
        : <Check className="w-3.5 h-3.5 text-green-600" />}
      {status === "saving" ? t("os.autosave.saving") : t("os.autosave.saved")}
    </div>
  );
};

export default AutosaveStatusPill;
